var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.61821 19V10.6899H9.3426L9.86094 7.24882H6.61821V5.01693C6.61821 4.07786 7.07332 3.15809 8.52086 3.15809H9.99368V0.23155C9.99368 0.23155 8.6536 0 7.37674 0C4.70923 0 2.9646 1.64658 2.9646 4.62458V7.24238H0V10.6835H2.97092V18.9936H6.62453L6.61821 19Z",
    fill: "#D1A437"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.2b8241c789fc55872db4b52f45c6fd26.svg";
export { ForwardRef as ReactComponent };